// Soft color pairs for name initials. The pair comes from the name, so a person
// keeps the same color wherever they appear or however a list is filtered.
const AVATAR_TONES = [
  ["#e0971f", "#e8741a"],
  ["#e11d74", "#f0589a"],
  ["#7c4ddb", "#9b7af0"],
  ["#0f9e8e", "#22c0a8"],
  ["#1d8fd1", "#3fb0ea"],
];

export const toneFor = (name) => {
  let hash = 0;
  for (const ch of String(name || "")) {
    hash = (hash * 31 + ch.codePointAt(0)) >>> 0;
  }
  return AVATAR_TONES[hash % AVATAR_TONES.length];
};

// First visible character (grapheme, so Devanagari conjuncts stay intact).
export const initialOf = (name) => {
  const text = String(name || "").trim();
  if (!text) return "•";
  const first =
    typeof Intl !== "undefined" && Intl.Segmenter
      ? [
          ...new Intl.Segmenter(undefined, { granularity: "grapheme" }).segment(
            text,
          ),
        ][0]?.segment
      : Array.from(text)[0];
  return (first || "•").toUpperCase();
};
